import { render, staticRenderFns } from "./CustomDelegationRateContent.vue?vue&type=template&id=ada71876&scoped=true&"
import script from "./CustomDelegationRateContent.vue?vue&type=script&lang=js&"
export * from "./CustomDelegationRateContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ada71876",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCheckbox,VCol,VDataTable,VForm,VIcon,VRow,VSpacer,VTextField,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ada71876')) {
      api.createRecord('ada71876', component.options)
    } else {
      api.reload('ada71876', component.options)
    }
    module.hot.accept("./CustomDelegationRateContent.vue?vue&type=template&id=ada71876&scoped=true&", function () {
      api.rerender('ada71876', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Settings/DelegationRate/CustomDelegationRateContent.vue"
export default component.exports